export const fonts = {
  body: `Myriad Pro, sans-serif`,
  heading: `GoBold, sans-serif`,
  headingSub: `GoodHeadline, sans-serif`,
  headingScript: `Stash, sans-serif`
};
